export default __webpack_public_path__ + "static/media/MAD_Whitepaper.554de249.pdf";